import React, { useState, useEffect } from "react";
import { useBoolean } from "@fluentui/react-hooks";
import i18n from "i18next";

import { fetchWrapper } from "../../helpers/fetchwrapper";
import TeamMemberSelection from "./TeamMemberSelection";

import { baseUrl } from "../../helpers/constants";
import {
  Dialog,
  Button,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Field,
  Divider,
  RadioGroup,
  Radio,
} from "@fluentui/react-components";
import { SaveRegular } from "@fluentui/react-icons";

interface IFreigabeDialogProps {
  isDialogOpen: boolean;
  objectGuid: string | undefined;
  referenceGuid: string;
  objectType: string;
  onDismiss(): any;
  onSave(): void;
}

function FreigabeDialog(props: IFreigabeDialogProps) {
  const [
    freigabeDialogIsOpen,
    { setTrue: showFreigabeDialog, setFalse: hideFreigabeDialog },
  ] = useBoolean(false);
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);

  const [freigabe, setFreigabe] = useState({ userfreigabe: 0, teams: [] });
  const handleFreigabeValuesChange = (name: string, val: any) => {
    setFreigabe((prevState: any) => ({
      ...prevState,
      [name]: val,
    }));
    setIsSaveEnabled(true);
  };

  useEffect(() => {
    if (props.isDialogOpen) {
      showFreigabeDialog();
    } else {
      hideFreigabeDialog();
    }
  }, [props.isDialogOpen]);

  const getFreigabeData = () => {
    if (props.objectGuid && props.objectType) {
      fetchWrapper
        .getWithAuth(
          `${baseUrl}/api/freigabe/GetFreigabeData?objectGuid=${props.objectGuid}&referenceGuid=&objectType=${props.objectType}`,
        )
        .then((data: any) => {
          setFreigabe(data);
          // userfreigabe: 0 = Privat, 1 = Teams, 2 = Individuell
        });
    }
  };

  const updateFreigabe = () => {
    fetchWrapper
      .postWithAuth(`${baseUrl}/api/freigabe/UpdateFreigabe`, freigabe)
      .then((result: any) => {
        getFreigabeData();
      });
  };

  const updateTeam = (updatedTeam: any) => {
    const updatedTeams = freigabe.teams.map((team: any) => {
      if (team.teamGuid == updatedTeam.teamGuid) {
        return updatedTeam;
      } else {
        return team;
      }
    });
    handleFreigabeValuesChange("teams", updatedTeams);
  };

  useEffect(() => {
    if (props.isDialogOpen) {
      getFreigabeData();
    }
  }, [props.isDialogOpen]);

  return (
    <div>
      <Dialog open={props.isDialogOpen}>
        <DialogSurface>
          <DialogBody>
            <DialogTitle>{i18n.t<string>("shareObject")}</DialogTitle>
            <DialogContent>
              <Field>
                <RadioGroup value={freigabe.userfreigabe.toLocaleString()}>
                  <Radio
                    value="0"
                    onChange={(ev, data) => {
                      handleFreigabeValuesChange("userfreigabe", 0);
                    }}
                    label={i18n.t<string>("permissionPrivate")}
                  />
                  <Radio
                    value="1"
                    onChange={(ev, data) => {
                      handleFreigabeValuesChange("userfreigabe", 1);
                    }}
                    label={i18n.t<string>("permissionTeams")}
                  />
                  <Radio
                    value="2"
                    onChange={(ev, data) => {
                      handleFreigabeValuesChange("userfreigabe", 2);
                    }}
                    label={i18n.t<string>("permissionIndividually")}
                  />
                </RadioGroup>
              </Field>

              {freigabe.userfreigabe == 2 && (
                <div>
                  <Divider appearance="brand"></Divider>
                  {freigabe.teams.map((team: any) => {
                    return (
                      <TeamMemberSelection
                        selectionChanged={(team: any) => updateTeam(team)}
                        team={team}
                      />
                    );
                  })}
                </div>
              )}
            </DialogContent>
            <DialogActions>
              <Button
                icon={<SaveRegular />}
                disabled={!isSaveEnabled}
                onClick={() => {
                  updateFreigabe();
                  hideFreigabeDialog();

                  props.onSave();
                }}
                appearance="primary"
              >
                {i18n.t<string>("save")}
              </Button>
              <Button
                onClick={() => {
                  props.onDismiss();
                }}
              >
                {i18n.t<string>("cancel")}
              </Button>
            </DialogActions>
          </DialogBody>
        </DialogSurface>
      </Dialog>
    </div>
  );
}

export default FreigabeDialog;
